
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */

import DocsBeta from 'src/components/docs/DocsBeta/index.tsx';

export const metadata = {
  toc: true,
  maxTocLevel: 4,
  layout: 'guide',
  section: 'Transfer',
  title: 'Reserves',
  description: 'Learn about Transfer reserves requirements'
};
const makeShortcode = name => function MDXDefaultShortcode(props) {
      console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
      return <div {...props}/>
    };
const Header = makeShortcode("Header");
const layoutProps = {
  metadata
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Header title='Reserves' subtitle={metadata.description} mdxType="Header" />
    <p>{`Reserves are static funds held by Plaid to mitigate the financial risks associated with ACH debit transactions. Holding funds in reserve with Plaid operates on a sliding scale, meaning that increasing the amount in reserves can lead to progressively lower ACH debit hold times and increased limits, with a few exceptions.`}</p>
    <h4 {...{
      "id": "why-reserves-are-required"
    }}>{`Why reserves are required`}</h4>
    <p>{`Reserves cover potential losses that Plaid may experience as a result of processing ACH debits. Reserves are a common industry practice used by payment processors and financial institutions to ensure that businesses have sufficient balance to return funds to end-users when necessary. `}</p>
    <p>{`ACH debits have financial risk because they can fail ("return") after settlement occurs. Even after funds have been transferred to Plaid, they can be returned back to the debited account up to 60 days after the transaction. This can occur due to a variety of reasons, including insufficient funds in the debited account; the debited account being inactive, closed, or blocked; or the consumer claiming the debit was unauthorized. If a customer does not have sufficient funds to cover the return, that will cause a negative balance and a potential loss to Plaid. `}</p>
    <h4 {...{
      "id": "how-plaid-uses-reserves"
    }}>{`How Plaid uses reserves`}</h4>
    <p>{`If a Ledger's available balance goes negative due to ACH debit returns, the balance will usually recover after a few days due to pending funds coming off hold. However, if the amounts of the available and pending balances are insufficient to cover the returned amounts, then Plaid will debit your linked funding account for that Ledger to recover the balance. `}</p>
    <p>{`Plaid will draw from reserves only if the owed amounts could not be recovered via payment processing or auto-initiated debits to the associated funding account.`}</p>
    <h4 {...{
      "id": "funding-your-reserves"
    }}>{`Funding your reserves`}</h4>
    <p>{`During your onboarding process, Plaid will calculate the required amount of reserve funds and options for number of hold days based on your use case, maximum transaction size, and expected volume of transactions. `}</p>
    <p>{`These options will be presented to you in your `}<a parentName="p" {...{
        "href": "/docs/transfer/application/#implementation-checklist"
      }}>{`Implementation checklist`}</a>{`. After selecting the number of hold days, you can see the corresponding reserve amount required. `}</p>
    <p>{`Your implementation checklist will show you the necessary details to initiate a wire transfer for the required reserve amount. Once Plaid receives the funds, they will be automatically allocated to your reserve balance.`}</p>
    <p>{`Your current reserve balance is displayed in the `}<a parentName="p" {...{
        "href": "https://dashboard.plaid.com/transfer/account-details"
      }}>{`Dashboard`}</a>{`. See the "Account Details" section to view the total amount currently held.`}</p>
    <h4 {...{
      "id": "changes-to-your-reserve-balance"
    }}>{`Changes to your reserve balance`}</h4>
    <p>{`The required reserve amount may be adjusted based on changes to ACH debit hold times, transaction limits, or return rates.`}</p>
    <p>{`If adjustments to your reserve amount are necessary, your Plaid account manager will communicate this to you and provide guidance.
For further assistance or to adjust your reserves, please contact your Plaid account manager directly.`}</p>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;

            export const tableOfContents = [
      {
        id: "why-reserves-are-required",
        level: 4,
        title: "Why reserves are required",
      },
{
        id: "how-plaid-uses-reserves",
        level: 4,
        title: "How Plaid uses reserves",
      },
{
        id: "funding-your-reserves",
        level: 4,
        title: "Funding your reserves",
      },
{
        id: "changes-to-your-reserve-balance",
        level: 4,
        title: "Changes to your reserve balance",
      }
];
          
layoutProps.tableOfContents = tableOfContents;
MDXContent.layoutProps = layoutProps;

MDXContent.layout = function (props) { return <DocsBeta {...props} /> };
